import React, { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { forEach } from 'lodash';

/**
 * Item Tabs
 * */
const ItemTabs = (props) => {
  const { children, questionIndex, tabContainers, onChange } = props;

  const [tabData, setTabData] = useState({
    selectedTabIndex: 0,
    visibleTabContainer: 'details',
  });
  const [tabScrollPositions, setTabScrollPositions] = useState({
    0: null,
    1: null,
  });

  const { selectedTabIndex, visibleTabContainer } = tabData;

  const saveTabScrollPosition = () => {
    let scrollPosition =
      'pageYOffset' in window ? window.pageYOffset : document.body.scrollTop;

    const existingPos = tabScrollPositions[selectedTabIndex];
    const hasExistingPos = existingPos !== 0 && existingPos !== null;

    if (scrollPosition > 0 || (scrollPosition === 0 && hasExistingPos)) {
      setTabScrollPositions({
        ...tabScrollPositions,
        [selectedTabIndex]: scrollPosition,
      });
    }
  };

  const scrollToCurrentTab = () => {
    const currentTabPosition = tabScrollPositions[selectedTabIndex];
    if (currentTabPosition !== null) {
      window.scrollTo(0, currentTabPosition);
    }
  };

  const setDisplayStyle = () => {
    const isFRQMultipart = tabContainers.responses.length > 1;
    const isDetailsTabVisible =
      selectedTabIndex === 0 && visibleTabContainer === 'details';
    const isResponsesTabVisible =
      selectedTabIndex === 1 && visibleTabContainer === 'responses';
    const visibleResponseContainer = tabContainers.responses[0];

    if (!isFRQMultipart && isDetailsTabVisible && visibleResponseContainer) {
      visibleResponseContainer.style.display = 'none';
    } else if (isResponsesTabVisible && visibleResponseContainer) {
      visibleResponseContainer.style.display = 'block';
    }
  };

  useEffect(() => {
    scrollToCurrentTab();
    setDisplayStyle();
  }, [selectedTabIndex, visibleTabContainer, tabContainers]);

  useLayoutEffect(() => {
    forEach(
      [...tabContainers.details, ...tabContainers.responses],
      (element) => {
        if (element) {
          element.classList.remove('is-visible');
          element.classList.remove('force-one-column');
          element.classList.add('is-hidden');
        }
      },
    );

    const visibleTabElement = tabContainers[visibleTabContainer];
    forEach(visibleTabElement, (element) => {
      if (element) {
        element.classList.add('is-visible');
        element.classList.add('force-one-column');
        element.classList.remove('is-hidden');
      }
    });
  }, [questionIndex, selectedTabIndex, visibleTabContainer]);

  useLayoutEffect(() => {
    const tabsContainerElement = document.querySelector('.mobile-tabs');
    /**
     * On scroll event handler
     * */
    const onScroll = () => {
      const windowTop = window.pageYOffset;
      const { top: itemTabsTop } = tabsContainerElement.getBoundingClientRect();
      if (windowTop > itemTabsTop) {
        tabsContainerElement.classList.add('is-sticky');
      } else {
        tabsContainerElement.classList.remove('is-sticky');
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  /**
   * On tabs change event callback
   * @param {object} event The event callback
   * @param {number} index The index of the tab
   * */
  const onTabsChange = (event, index) => {
    const container = index === 0 ? 'details' : 'responses';
    setTabData({
      selectedTabIndex: index,
      visibleTabContainer: container,
    });
    saveTabScrollPosition();
    if (onChange) {
      onChange(container);
    }
  };

  const classes = {
    tabsRoot: {
      root: 'mobile-tabs-root',
      indicator: 'mobile-tabs-selected-indicator',
    },
    tabItem: {
      root: `mobile-tabs-item`,
      selected: 'mobile-tabs-item-is-selected',
    },
  };
  const { tabsRoot, tabItem } = classes;

  return (
    <Fragment>
      <Tabs
        classes={tabsRoot}
        variant="fullWidth"
        value={selectedTabIndex}
        onChange={onTabsChange}
      >
        <Tab
          classes={tabItem}
          tabIndex={0}
          label={`Question ${questionIndex}`}
        />
        <Tab classes={tabItem} tabIndex={0} label="My Response" />
      </Tabs>
      {children &&
        React.cloneElement(children, {
          itemsLocation: visibleTabContainer,
        })}
    </Fragment>
  );
};

ItemTabs.defaultProps = {
  onChange: null,
};

ItemTabs.propTypes = {
  questionIndex: PropTypes.number.isRequired,
  tabContainers: PropTypes.shape({
    details: PropTypes.arrayOf(PropTypes.instanceOf(Element)).isRequired,
    responses: PropTypes.arrayOf(PropTypes.instanceOf(Element)).isRequired,
  }).isRequired,
  columnsNr: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

export default ItemTabs;
